import { makeStyles, tokens } from "@fluentui/react-components";

export const useStyles = makeStyles({
  container: {
    display: "flex",
    flexDirection: "column",
    flexWrap: "nowrap",
    alignItems: "flex-start",
    rowGap: "5px",
    height: "100%",
    width: "100%",
  },
  appContainer: {
    flex: "0 0 auto",
    flexGrow: 1,
    width: "100%",
  },
  tabContainer: {
    display: "flex",
    alignItems: "flex-end",
    width: "100%",
    backgroundColor: tokens.colorBrandBackground2,
    padding: "5px 0 0 0",
  },
  centeredContainer: {
    alignSelf: "center",
  },
  flexCentered: {
    height: "100%",
    alignSelf: "center",
  },
});
